import {
  Button,
  Dialog,
  Grid,
  Loader,
  Modal,
  Spinner,
  Text,
  toast,
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { useTranslation } from 'react-i18next';
import { generatePreSignedUrl } from 'client/api-utils';
import { useFetch } from 'client/hooks/use-fetch';
import { routes } from 'client/views/navigation/routes/routes';

type ShareObjectModalProps = {
  visible: boolean
  onClose: () => void,
  name: string,
  objectid: string
};

export const ShareObjectModal = ({
  visible,
  onClose,
  name,
  objectid,
}: ShareObjectModalProps) => {
  const { t } = useTranslation();
  const { isLoading, response: presignedUrl, errMesg } = useFetch<{ url: string }, string[]>(generatePreSignedUrl, null, [objectid], objectid);

  const copyToClipboard = async () => {
    try {
      const navigationUrl = window.location.origin + routes.sharedObjects.fullPath.replace(':preSignedUrlKey', presignedUrl!.url);
      await navigator.clipboard.writeText(navigationUrl);
      toast({
        message: {
          type: 'Info',
          icon: true,
          content: 'Info',
          details: t(translations.objects_copiedToBuffer),
        }, 
      });
    } catch (error: any) {
      errMesg(error);
    }
  };
  
  const content = isLoading 
    ? (
      <Loader height="50px" theme="light" details={t(translations.objects_generatingUrl)}>
        <Spinner dark />
      </Loader>
    ) : (
      <Grid gap={10}>
        <Text>
          {t(translations.objects_shareInfo, { name })}
        </Text>
      </Grid>
    );

  return (
    <Modal visible={visible} centered>
      <Dialog
        dialog={{
          scroll: false,
          heading: `${t(translations.share)}: ${name}`,
          content,
          width: 500,
          onClose,
          footer: (
            <>
              <Button onClick={copyToClipboard} label={t(translations.copy)} colored />
              <Button onClick={onClose} label={t(translations.cancel)} />
            </>
          ),
        }}
      />
      
    </Modal>
  );
};